var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2A356"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 44C39.1274 44 44.5 38.6274 44.5 32C44.5 25.3726 39.1274 20 32.5 20C25.8726 20 20.5 25.3726 20.5 32C20.5 38.6274 25.8726 44 32.5 44Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5007 40.6663C32.8688 40.6663 33.1673 40.3679 33.1673 39.9997C33.1673 39.6315 32.8688 39.333 32.5007 39.333C32.1325 39.333 31.834 39.6315 31.834 39.9997C31.834 40.3679 32.1325 40.6663 32.5007 40.6663Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 37.3333V35.4413C32.5 34.1827 33.3053 33.0653 34.5 32.6667C35.0823 32.4725 35.5888 32.1001 35.9478 31.6021C36.3067 31.1041 36.4999 30.5059 36.5 29.892V29.208C36.5 27.0667 34.7667 25.3333 32.6253 25.3333H32.5C31.4391 25.3333 30.4217 25.7548 29.6716 26.5049C28.9214 27.2551 28.5 28.2725 28.5 29.3333",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.82a208ab6f859de0ea241e08a8f3d984.svg";
export { ForwardRef as ReactComponent };